import { Reference, ReferencesContextTypes } from '../../interfaces';
import { ReferencesState } from './';

type ReferencesActionType = 
| { type: ReferencesContextTypes.ACTION_TYPE_SET_NEW_REFERENCE, payload: Reference}
// | { type: ReferencesContextTypes.ACTION_TYPE_CLOSE_SIDEBAR}

export const referencesReducer = ( state: ReferencesState, action: ReferencesActionType ): ReferencesState => {
    switch (action.type) {
        case ReferencesContextTypes.ACTION_TYPE_SET_NEW_REFERENCE:
            return{
                reference: action.payload
            }
        default:
            return state;
    }
}